import template from './vault_balance.html';
import controller from './vault_balance.controller';
import './vault_balance.scss';

let vaultBalanceComponent = {
    restrict: 'E',
    template,
    controller
};

export default vaultBalanceComponent;



// WEBPACK FOOTER //
// ./client/app/components/vault_balance/vault_balance.component.js